import React from "react";
import withFooter from "../../hocs/withFooter";
import withHeader from "../../hocs/withHeader";
import PersonalInformationSection from "./PersonalInformationSection";
import CredentialsSection from "./CredentialsSection";
import SubscriptionDetailsSection from "./SubscriptionDetailsSection";

function AccountPage() {
    return (
        <section className="account">
            <div className="container">
                <h1 className="pv-xl">My account</h1>

                <PersonalInformationSection />
                <CredentialsSection />
                <SubscriptionDetailsSection />
            </div>
        </section>);
}

export default withHeader(withFooter(AccountPage));